import Recorder from 'recorder-js';

window.training = (params) => {
    let retryCount = 0;
    const maxRetries = 1;

    // Настройки VAD
    const FRAME_MS = 20;                 // как часто считать RMS (~50 Гц)
    const START_RMS = 0.035;             // порог "начала речи"
    const STOP_RMS  = 0.02;             // порог "тишины" (ниже стартового — гистерезис)
    const MIN_ACTIVE_MS_BEFORE_START = 120; // минимум активной речи до старта (антишип)
    const SILENCE_TO_STOP_MS = 2000;     // 2 сек тишины — останавливаем запись
    const RESTART_COOLDOWN_MS = 400;     // защита от мгновенного перезапуска после стопа

    let isDialog = params.isDialog;
    let recorder;
    let audioContext, analyser, microphone;
    let mediaStream = null; // ссылка на поток, чтобы корректно останавливать микрофон на мобильных
    let silenceTimeout;
    let isRecording = false;
    let isTracking = false;
    let socket;
    let recordingInterval;
    let text = '';

    const setProfileControlsDisabled = (isDisabled) => {
        $('#training-personality').prop('disabled', isDisabled);
        $('#training-direction').prop('disabled', isDisabled);
    };

    // Инициализация обработчиков кнопок
    const init = () => {

        if (isDialog) {
            $('#start-training').text('Продолжить тренировку')
            $('#save-training').show()
            $('#save-start-training').show()
            setProfileControlsDisabled(true);
        }

        $('#start-training').on('click', () => handleStartTraining());

        $('#stop-training').on('click', () => handleStopTraining());

        $('#save-training').on('click', () => handleSaveTraining())

        $('#save-start-training').on('click', () => handleSaveStartTraining())

        $(window).on('beforeunload', () => {
            if (isDialog) {
                return 'Вы точно хотите покинуть страницу? результат тренировки будет потерян';
            }
        })
    };

    // Подготовка адреса WebSocket с учётом http/https и разных форматов переменной окружения
    const makeWsUrl = () => {
        const raw = (process.env.MIX_RATCHET_URL || '').trim();
        const isHttps = window.location.protocol === 'https:';
        const scheme = isHttps ? 'wss' : 'ws';

        try {
            if (raw) {
                if (raw.startsWith('ws://') || raw.startsWith('wss://')) {
                    return raw;
                }
                if (raw.startsWith('//')) {
                    return `${scheme}:${raw}`; // protocol-relative -> ws/wss
                }
                // host:port
                if (/^[^\/]+:\d+$/.test(raw)) {
                    return `${scheme}://${raw}`;
                }
                // absolute path
                if (raw.startsWith('/')) {
                    return `${scheme}://${window.location.host}${raw}`;
                }
                // hostname or hostname/path
                return `${scheme}://${raw}`;
            }
        } catch (e) {
            console.warn('Cannot normalize MIX_RATCHET_URL, using fallback', e);
        }

        // Фолбэк: тот же хост, порт 8777
        return `${scheme}://${window.location.hostname}:8777`;
    };

    const initSocket = () => {
        const wsUrl = makeWsUrl();
        try {
            socket = new WebSocket(wsUrl);
        } catch (e) {
            console.error('Неверный адрес WebSocket:', wsUrl, e);
            $('#loader').text('Ошибка адреса WebSocket');
            return;
        }

        socket.onopen = () => {
            console.log('WebSocket соединение установлено');
            $('#loader').text('Говорите');
        };

        socket.onmessage = (event) => {
            console.log(event.data);
            text += event.data + ' ';
        };

        socket.onerror = (error) => {
            console.error('Ошибка WebSocket', error);
            if (isRecording) {
                isTracking = true;
            }
        };

        socket.onclose = (event) => {
            if (!event.wasClean) {
                console.warn('Соединение прервано. Попытка повторного подключения...');
                setTimeout(initSocket, 1000);
            }
        };
    };

    // Разблокировка/возобновление AudioContext при жесте пользователя (iOS/Android)
    const ensureAudioContext = async () => {
        if (!audioContext) {
            const Ctx = window.AudioContext || window.webkitAudioContext;
            audioContext = new Ctx();
        }
        if (audioContext.state === 'suspended') {
            try { await audioContext.resume(); } catch (e) { /* no-op */ }
        }
        // Для iOS: короткий «тихий» тик для разблокировки воспроизведения
        try {
            const osc = audioContext.createOscillator();
            const gain = audioContext.createGain();
            gain.gain.value = 0.00001;
            osc.connect(gain).connect(audioContext.destination);
            osc.start(); osc.stop(audioContext.currentTime + 0.01);
        } catch (e) { /* ignore */ }
    };

    // Простая обёртка над getUserMedia с поддержкой старых браузеров (iOS Safari)
    const getUserMediaCompat = (constraints) => {
        const nav = navigator;
        if (nav.mediaDevices && typeof nav.mediaDevices.getUserMedia === 'function') {
            return nav.mediaDevices.getUserMedia(constraints);
        }
        const legacy = nav.getUserMedia || nav.webkitGetUserMedia || nav.mozGetUserMedia || nav.msGetUserMedia;
        if (legacy) {
            return new Promise((resolve, reject) => legacy.call(nav, constraints, resolve, reject));
        }
        return Promise.reject(new Error('getUserMedia не поддерживается в этом браузере'));
    };

    // Старт сессии записи с доступом к микрофону
    const startRecordingSession = async () => {
        try {
            await ensureAudioContext();

            // Простые констрейнты для лучшей совместимости iOS/Android
            const constraints = { audio: { echoCancellation: true, noiseSuppression: true } };

            // Проверка безопасного контекста: на мобильных getUserMedia требует HTTPS
            if (window.isSecureContext === false && window.location.hostname !== 'localhost') {
                throw new Error('Нужен безопасный контекст (HTTPS). Откройте страницу по https://');
            }

            mediaStream = await getUserMediaCompat(constraints);

            analyser = audioContext.createAnalyser();
            microphone = audioContext.createMediaStreamSource(mediaStream);
            microphone.connect(analyser);

            recorder = new Recorder(audioContext);
            await recorder.init(mediaStream);

            isTracking = true;
            checkVolumeToStartRecording();
        } catch (err) {
            console.error('Не удалось получить доступ к микрофону', err);
            $('#loader').text('Разрешите доступ к микрофону в браузере');
        }
    };

    const computeRMS = (u8) => {
        let sumSq = 0;
        for (let i = 0; i < u8.length; i++) {
            const centered = (u8[i] - 128) / 128; // -1..+1
            sumSq += centered * centered;
        }
        return Math.sqrt(sumSq / u8.length);
    }

    // Отслеживание уровня сигнала: когда начинать/останавливать запись
    const checkVolumeToStartRecording = () => {
        if (!isTracking) {
            requestAnimationFrame(checkVolumeToStartRecording);
            return;
        }

        const bufferLength = analyser.fftSize;
        const dataArray = new Uint8Array(bufferLength);
        analyser.getByteTimeDomainData(dataArray);

        const rms = computeRMS(dataArray);

        if ((performance.now() | 0) % 500 < 16) {
            console.log('Volume: ' + rms);
        }

        // Начать запись, если уровень выше порога
        if (rms >= START_RMS && !isRecording) {
            startRecording();
        }

        // Остановить запись после 2 секунд тишины
        if (isRecording && rms <= STOP_RMS) {
            if (!silenceTimeout) {
                silenceTimeout = setTimeout(() => {
                    $('#loader').text('Ожидаем ответ пациента');
                    stopRecording();
                }, 2000);
            }
        } else if (isRecording && rms >= STOP_RMS) {
            clearTimeout(silenceTimeout);
            silenceTimeout = null;
        }

        requestAnimationFrame(checkVolumeToStartRecording);
    };

    // Запуск записи
    const startRecording = () => {
        isRecording = true;
        recorder.start().then(() => {
            $('#loader').text('Говорите');
            console.log('Запись началась');
            // Отправка аудиофрагментов раз в секунду
            recordingInterval = setInterval(() => {
                sendRecordingChunk();
            }, 1000);
        }).catch(err => {
            console.error('Ошибка при запуске записи', err);
        });
    };

    // Отправка очередного аудиофрагмента
    const sendRecordingChunk = () => {
        if (!isRecording) return;
        recorder.stop().then(({ blob }) => {
            if (socket && socket.readyState === WebSocket.OPEN) {
                socket.send(blob);
            } else {
                console.error('WebSocket соединение не открыто');
            }
            recorder.start();
        }).catch(err => {
            console.error('Ошибка при отправке фрагмента записи', err);
        });
    };

    // Остановка записи
    const stopRecording = () => {
        isTracking = false;
        isRecording = false;

        clearInterval(recordingInterval);
        recorder.stop().then(({ blob }) => {
            if (socket && socket.readyState === WebSocket.OPEN) {
                socket.send(blob);
            }
            sendTextToServer();
        }).catch(err => {
            console.error('Ошибка при остановке записи', err);
            sendTextToServer();
        });
    };

    // Воспроизведение аудио-ответа через Web Audio API (обходит запрет автоплея)
    const playAudioFromUrl = async (url) => {
        try {
            await ensureAudioContext();
            const res = await fetch(url, { credentials: 'include' });
            const arrBuf = await res.arrayBuffer();
            // decodeAudioData в Safari бывает коллбековая; но промис также поддерживается
            const audioBuffer = await audioContext.decodeAudioData(arrBuf);
            const src = audioContext.createBufferSource();
            src.buffer = audioBuffer;
            src.connect(audioContext.destination);

            return new Promise((resolve, reject) => {
                src.onended = resolve;
                try {
                    src.start();
                } catch (e) {
                    reject(e);
                }
            });
        } catch (e) {
            // Пробуем HTMLAudio как запасной вариант
            return new Promise((resolve, reject) => {
                try {
                    const audio = new Audio(url);
                    try {
                        audio.crossOrigin = 'anonymous';
                        audio.setAttribute('playsinline', 'true');
                    } catch {}
                    audio.addEventListener('ended', resolve);
                    audio.play().catch(reject);
                } catch (err) {
                    reject(err);
                }
            });
        }
    };

    // Отправка распознанного текста на сервер
    const sendTextToServer = () => {
        let formData = new FormData();
        formData.append('text', text);

        $.ajax({
            url: '/ii-call/training/recognition',
            type: 'POST',
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(response) {
                console.log('Аудио успешно отправлено!', response);

                // Воспроизведение ответа ассистента, если есть URL (через Web Audio)
                if (response.audioUrl) {
                    $('#loader').text('Слушаем пациента');
                    playAudioFromUrl(response.audioUrl)
                        .then(() => {
                            isTracking = true;
                            if (!isRecording) startRecording();
                        })
                        .catch(err => {
                            console.error('Ошибка воспроизведения:', err);
                            alert('Браузер заблокировал автозапуск аудио. Нажмите «Включить звук» и попробуйте снова.');
                            // Даем возможность продолжить без звука, чтобы не зависать
                            isTracking = true;
                            if (!isRecording) startRecording();
                        });
                } else {
                    retryCount = 0;
                    isTracking = true;
                    startRecording();
                }

                // Обновление блока диалога в интерфейсе
                if (response.dialog && Array.isArray(response.dialog)) {
                    const dialogContainer = $('#dialog');
                    dialogContainer.empty();
                    response.dialog.forEach(item => {
                        const messageElement = `<p class="${item.role}"><strong>${item.role}:</strong> ${item.content}</p>`;
                        dialogContainer.append(messageElement);
                    });
                }

                text = '';
            },
            error: function(error) {
                console.error('Ошибка отправки аудио', error);

                if (retryCount < maxRetries) {
                    retryCount++;
                    $.ajax(this);
                } else {
                    isTracking = true;
                }
            }
        });
    };

    // Остановка отслеживания голоса и освобождение ресурсов
    const stopTracking = () => {
        isTracking = false;
        isRecording = false;
        clearInterval(recordingInterval);
        // Останавливаем все треки микрофона — важно для iOS/Android
        if (mediaStream) {
            try { mediaStream.getTracks().forEach(t => t.stop()); } catch {}
            mediaStream = null;
        }
        if (silenceTimeout) {
            clearTimeout(silenceTimeout);
            silenceTimeout = null;
        }
        console.log('Отслеживание завершено');
    };

    const updateQuota = (response) => {
        $('#count-training').text(
            response.countTraining > 0
                ? "Осталось " + response.countTraining + " тренировок"
                : "Тренировки закончились"
        );

        if (!response.quota) {
            return;
        }

        let details = '';
        if (response.quota.personalLimit !== null) {
            details += 'Личный лимит: использовано '
                + response.quota.personalUsed
                + ' из '
                + response.quota.personalLimit
                + '. ';
        }
        details += 'Общий остаток компании: '
            + response.quota.companyRemaining
            + ' из '
            + response.quota.companyLimit
            + '.';

        $('#training-quota-details').text(details);
    };

    // Очистка диалога на сервере и в UI
    const clearDialogue = () => {
        $.ajax({
            url: '/ii-call/training/clear',
            type: 'POST',
            success: function(response) {
                updateQuota(response)
                if (response.countTraining === 0) {
                    $('#start-training').prop('disabled', true)
                    $('#stop-training').prop('disabled', true)
                    $('#clear-training').prop('disabled', true)
                }
                $('#dialog').empty();
                isDialog = false;
                setProfileControlsDisabled(false);
            },
            error: function(error) {
                console.error('Ошибка очистки диалога', error);
            }
        });
    };

    const handleStartTraining = () => {
        // Разблокировываем аудио по пользовательскому клику сразу
        ensureAudioContext();

        if (!isDialog) {
            const personality = $('#training-personality').val();
            const direction = $('#training-direction').val();

            $.ajax({
                url: '/ii-call/training/init',
                type: 'POST',
                data: {
                    personality: personality,
                    direction: direction,
                },
                success: function(response) {
                    updateQuota(response)
                    if (response.error) {
                        if (response.countTraining <= 0) {
                            $('#start-training').prop('disabled', true);
                        }
                        alert(response.error);
                        return;
                    }
                    if (response.dialog && Array.isArray(response.dialog)) {
                        const dialogContainer = $('#dialog');
                        dialogContainer.empty();
                        response.dialog.forEach(item => {
                            const messageElement = `<p class="${item.role}"><strong>${item.role}:</strong> ${item.content}</p>`;
                            dialogContainer.append(messageElement);
                        });
                    }

                    // Создаём WebSocket и запускаем сессию записи
                    initSocket();
                    startRecordingSession();

                    $('#start-training').text('Продолжить тренировку').prop('disabled', true)
                    $('#stop-training').prop('disabled', false)
                    $('#save-training').show().prop('disabled', false)
                    $('#save-start-training').show().prop('disabled', false)
                    setProfileControlsDisabled(true);

                    isDialog = true;
                },
                error: function(error) {
                    console.error('Ошибка начала диалога', error);
                }
            });
        } else {
            // Создаём WebSocket и запускаем сессию записи
            initSocket();
            startRecordingSession();

            $('#start-training').text('Продолжить тренировку').prop('disabled', true)
            $('#stop-training').prop('disabled', false)
            $('#save-training').show().prop('disabled', false)
            $('#save-start-training').show().prop('disabled', false)
            setProfileControlsDisabled(true);
        }


    }

    const handleStopTraining = () => {
        // Останавливаем отслеживание и закрываем WebSocket
        stopTracking();
        if (socket) {
            socket.close();
        }
        $('#loader').text('Запись остановлена');
        $('#start-training').prop('disabled', false)
        $('#stop-training').prop('disabled', true)
    }

    const handleSaveTraining = () => {
        stopTracking();
        if (socket) {
            socket.close();
        }
        $('#loader').text('Запись остановлена');

        $.ajax({
            url: '/ii-call/training/save',
            type: 'POST',
            success: function(response) {
                updateQuota(response)
                if (response.countTraining === 0) {
                    $('#start-training').prop('disabled', true)
                    $('#stop-training').prop('disabled', true)
                    $('#clear-training').prop('disabled', true)
                }
                $('#dialog').empty();
                isDialog = false
                setProfileControlsDisabled(false);
            },
            error: function(error) {
                console.error('Ошибка очистки диалога', error);
            }
        });

        $('#start-training').text('Начать тренировку').prop('disabled', false)
        $('#stop-training').prop('disabled', true)
        $('#save-training').hide()
        $('#save-start-training').hide()

    };

    const handleSaveStartTraining = () => {
        $.ajax({
            url: '/ii-call/training/clear',
            type: 'POST',
            success: function(response) {
                updateQuota(response)
                if (response.countTraining === 0) {
                    $('#start-training').prop('disabled', true)
                    $('#stop-training').prop('disabled', true)
                    $('#save-training').hide()
                    $('#save-start-training').hide()
                }
                $('#dialog').empty();

                isDialog = false;
                setProfileControlsDisabled(false);
                if (response.countTraining > 0) {
                    handleStartTraining();
                }
            },
            error: function(error) {
                console.error('Ошибка очистки диалога', error);
            }
        });
    }

    init();
};
